import { Reachability } from '@aws-amplify/core/internals/utils';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const ReachabilityMonitor = () => new Reachability().networkMonitor();

export { ReachabilityMonitor };
//# sourceMappingURL=index.mjs.map
